webpackJsonp([267695594480457],{

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Footer = __webpack_require__(104);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var Support = function Support() {
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Terms of Use / Privacy Policy" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Terms of Use"
	        ),
	        _react2.default.createElement(
	          "p",
	          { "class": "meta" },
	          "Effective Date: August 21, 2024 \xA0\xB7\xA0 Last Updated: June 5, 2026 \xA0\xB7\xA0 Site: ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.projectsurfhelmet.com" },
	            "projectsurfhelmet.com"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "highlight-box" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "The short version:"
	          ),
	          " This is a personal hobby site run by one surfer. Everything here is opinion. Nothing is professional safety advice. Your equipment decisions are your own. I make a small affiliate commission on some purchases at no cost to you. Use this site at your own risk."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "1. About This Site"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Project Surf Helmet is a personal hobby project operated by one individual \u2014 not a company, LLC, corporation, or any other legal business entity. There is no team, no staff, and no commercial organization behind this site. It exists purely because I am a surfer who cares about reducing head injuries in the water and wants to share honest research with other surfers."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "By accessing this site, you agree to these terms. If you do not agree, please stop using the site."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "2. Everything Here Is Personal Opinion"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Every review, ranking, comparison, rating, recommendation, or statement on this site \u2014 including any content about helmet materials, foam technologies, safety characteristics, or fitness for purpose \u2014 is strictly my personal opinion based on my own research, reading, and experience. I am not an engineer, a certified safety tester, a materials scientist, or a medical professional."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Nothing on this site constitutes professional safety advice, engineering analysis, medical guidance, regulatory certification, or any form of expert recommendation. No content on this site should substitute for professional evaluation or official safety certifications."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "3. Assumption of Risk & No Liability"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Surfing involves inherent and serious risks of injury or death regardless of what equipment you choose. By using this site, you expressly acknowledge and agree that:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Any decision about which helmet to purchase, wear, or recommend to others is yours alone."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I accept no responsibility whatsoever for any injury, death, property damage, financial loss, or other harm of any kind arising from your use or non-use of any product discussed or linked to on this site."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "All content is consumed entirely at your own risk."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I make no warranties \u2014 express or implied \u2014 about the accuracy, completeness, currency, or reliability of any information on this site."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Product specifications, safety ratings, prices, availability, and manufacturer details change frequently. Always verify directly with the manufacturer or retailer before making any purchasing decision."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Helmet performance in any real-world situation can differ significantly from anything described in a review."
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            "To the maximum extent permitted by applicable law, I expressly disclaim all liability for any direct, indirect, incidental, special, consequential, exemplary, or punitive damages arising from your use of this site, your reliance on any content herein, or any decision made in connection with this site."
	          ),
	          " ",
	          "This disclaimer applies whether the claim is based in contract, tort, negligence, strict liability, or any other legal or equitable theory."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If any limitation of liability in these terms is found unenforceable by a court, that limitation will be enforced to the maximum extent permitted by law, and all other limitations remain in full effect."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "4. Affiliate Disclosure"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site participates in affiliate programs, including the Amazon Associates Program and potentially other retailer affiliate programs. This means I may earn a small commission if you purchase a product through a link on this site \u2014 at no additional cost to you."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Affiliate relationships ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "never"
	          ),
	          " influence my reviews or rankings. My only goal is to give honest assessments to help surfers make better-informed decisions about safety equipment. Products I review negatively often have affiliate links too."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "5. No Accounts or Payments"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site has no user registration system and does not accept payments of any kind. You do not need to provide any personal information to read content on this site."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "6. External Links"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site contains links to third-party websites including product pages, manufacturer sites, and academic research. I have no control over and take no responsibility for the content, accuracy, safety, privacy practices, or terms of any linked external site. Following an external link is entirely at your own risk."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "7. Intellectual Property"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "All original content on this site \u2014 including text, original photographs, and graphics created by me \u2014 is my personal intellectual property. You may quote or reference content from this site with appropriate attribution. Wholesale copying, republication, or commercial use of site content is not permitted without prior written permission."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "For copyright or DMCA inquiries, contact:",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "8. Children"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site is not directed at children under 13. I do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has submitted information through this site, please contact me and I will delete it."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "9. Prohibited Conduct"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "You agree not to:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Scrape, crawl, or systematically harvest content from this site without permission."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Use this site's content for commercial purposes without written permission."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Attempt to interfere with or disrupt the technical operation of the site."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Use automated tools to access or interact with the site in ways not intended for normal browsing."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Reproduce or misrepresent site content in a way that could mislead others about its source or nature."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "10. \"As-Is\" Disclaimer"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site and all its content are provided on an \"as-is\" and \"as-available\" basis without warranties of any kind. I make no representation that this site will be uninterrupted, error-free, or free of harmful code. Use of this site is entirely at your own risk."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "11. Governing Law"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site is operated by an individual residing in California, USA. These terms are governed by the laws of the State of California to the extent any legal framework applies to a personal hobby website. Nothing in these terms limits any consumer rights you may have under the laws of your own jurisdiction."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "12. Changes to These Terms"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "I may update these terms at any time. The \"Last Updated\" date at the top of this page will reflect any changes. Continued use of the site after an update constitutes acceptance of the revised terms."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "13. Contact"
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "contact-block" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Project Surf Helmet"
	          ),
	          _react2.default.createElement("br", null),
	          "Personal hobby site \u2014 Long Beach, CA, USA",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Support.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Support);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-17139bb7cbaaf2c831cc.js